// Architecture.jsx
import { useEffect } from 'react';

const Architecture = () => {
  useEffect(() => {
    window.location.href = 'https://ksakongu.edu.in/';
  }, []);

  return null; 
};

export default Architecture;
